export enum Region {
  BELARUS = "BY",
  RUSSIA = "RU",
  POLAND = "PL",
  LITHUANIA = "LT",
  GEORGIA = "GE"
}